import { render } from "./TemplateView.vue?vue&type=template&id=6fa1e07c&scoped=true"
import script from "./TemplateView.vue?vue&type=script&lang=js"
export * from "./TemplateView.vue?vue&type=script&lang=js"

import "./TemplateView.vue?vue&type=style&index=0&id=6fa1e07c&scoped=true&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa1e07c"]])

export default __exports__